module.exports = "/images/zink-it-comprehensive.png?18ed8ae503a38b7647fd33c78c92b870";